import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

// Minimalist round toggle. Icon swaps with the theme.
export default function ThemeToggle({ className = '' }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
      data-testid="theme-toggle-btn"
      className={
        'inline-flex items-center justify-center h-10 w-10 rounded-full ' +
        'bg-surface-2 hover:bg-primary/15 text-foreground hover:text-primary ' +
        'transition-colors duration-200 ring-1 ring-border ' +
        className
      }
    >
      {isDark ? (
        <Sun className="w-5 h-5" strokeWidth={1.6} />
      ) : (
        <Moon className="w-5 h-5" strokeWidth={1.6} />
      )}
    </button>
  );
}
